<ion-card (click)="goToQuotes()" *ngIf="facility && facility.QuotesEnabled">
  <ion-card-header class="ion-text-center">
    <ion-card-title>Quote Request</ion-card-title>
    <i class="fal fa-paper-plane facility-quote-icon facility-icon"></i>
  </ion-card-header>
  <ion-card-content>
      <ion-card-subtitle class="ion-text-center">Request Quotes, History, Replacement Heat Map</ion-card-subtitle>
  </ion-card-content>
</ion-card>